module.exports = __webpack_public_path__ + "static/media/mastercard_logo.30ad9e52.png";